export default __webpack_public_path__ + "static/media/trophy.500ce7d9.svg";